<template>
    <div>
      <h1 class="page-heading">Paramètres</h1>
    </div>
  </template>
  
  <script>
  import { defineComponent } from 'vue'
  
  export default defineComponent({
    name: 'SettingsView'
  })
  </script>